import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ApexOptions} from 'ng-apexcharts';
import {WidgetChartControllerComponent} from '../../../Controller/widget-chart-controller-component';
import {PieChartDto} from '../../../../Models/Chart/pie-chart.interface';

@Component({
  selector: 'app-widget-pie-chart',
  templateUrl: './widget-pie-chart.component.html',
  styleUrls: ['./widget-pie-chart.component.scss'],
  standalone: false
})
export class WidgetPieChartComponent extends WidgetChartControllerComponent implements OnChanges {

  @Input() data!: PieChartDto | null;

  chartOptions!: ApexOptions;


  /**
   * Se ejecuta si hay cambios en la variable 'data'
   *
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.initChart();
    }
  }


  /**
   * Inicializar gráfica
   *
   */
  initChart() {
    this.chartOptions = {
      chart: {
        type: 'pie',
        height: 375,
        toolbar: {
          show: false
        }
      },
      labels: this.data?.categories || [],
      series: this.data?.series || [],
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }
      ],
      legend: {
        position: 'bottom',
        offsetY: 0,
        height: 150,
        itemMargin: {
          horizontal: 5,
          vertical: 2
        },
        formatter: function (val: string) {
          return val.length > 25 ? val.substring(0, 25) + '...' : val;
        }
      },
      dataLabels: {
        enabled: true,
        formatter: ((value: number): string => `${value.toFixed(1)}%`),
      }
    };
  }

} 
